import type { CertificateRequestIntentDto } from "@/services/certificateRequestIntentsService";
import { apiClient } from "@/services/apiClient";

export type UpsertCertificateRequestIntentBody = {
  slug: string;
  status: "active" | "coming_soon" | "hidden";
  flowKey: "certificate_catalog" | "open_company" | "enterprise_catalog" | "quote_request";
  sortOrder?: number;
};

export function listPlatformCertificateRequestIntents(): Promise<CertificateRequestIntentDto[]> {
  return apiClient
    .get<CertificateRequestIntentDto[]>("/platform/certificate-request-intents")
    .then((res) => res.data);
}

export function upsertCertificateRequestIntent(
  body: UpsertCertificateRequestIntentBody
): Promise<CertificateRequestIntentDto> {
  return apiClient
    .put<CertificateRequestIntentDto>("/platform/certificate-request-intents", body)
    .then((res) => res.data);
}
